angular.module('callX').controller('DispositionConfirmationCtrl', ['$scope', '$rootScope','$modal', '$modalInstance', '$state', 'UserService', 'object', 'toaster', '$stateParams', function($scope,$rootScope, $modal,$modalInstance, $state, UserService, object,toaster, $stateParams) {

    $scope.obj = object;
    console.log($scope.obj, "get object")
    $scope.applicationSubmittedStatus = $scope.obj.showApplicationSubmitted;
    $scope.showAnotherCallPrompt = $scope.obj.showConfirmation;

   $scope.confirmDispositionSubmit = function(answer) {
        if (answer === 'Yes' || answer === 'No') {
            $modalInstance.close(answer);
        }
    };

}]);